export enum PageTemplateType {
    Page,
    Embed,
    Section
}
